import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import VisualizationContext from '../../../../../contexts/VisualizationContext';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';

type PageSubHeaderLeadsProps = {
  title?: string;
  isBeta?: boolean;
  isGestor?: boolean;
};

export const PageSubHeaderLeads = ({
  title,
  isGestor,
  isBeta
}: PageSubHeaderLeadsProps) => {
  const isMobile = useMediaQuery('(max-width: 920px)');

  const navigate = useNavigate();

  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);

  const handleVisualizationState = (value: string) => {
    navigate('/corretor/leads');

    setVisualizationState(value);
  };

  return (
    <div className="tw-bg-[#ebebeb] tw-px-[16px] tw-py-[30px] md:tw-px-14 md:tw-py-[1.88rem]">
      <div
        className={
          isMobile
            ? 'tw-flex tw-flex-col tw-justify-between tw-items-start'
            : 'tw-flex tw-justify-between tw-items-center'
        }
      >
        <div className="tw-flex tw-gap-[0.63rem] tw-justify-center tw-items-center">
          <h1
            className={
              isMobile
                ? 'tw-text-[1.5rem] tw-font-bold'
                : 'tw-text-2xl tw-font-bold'
            }
          >
            {title}
          </h1>
          {isBeta ? (
            <p className="tw-bg-[#001E64] tw-text-white tw-text-[0.75rem] tw-w-[2.4375rem] tw-h-[1.5rem] tw-rounded-[0.46875rem] tw-flex tw-justify-center tw-items-center">
              Beta
            </p>
          ) : null}
        </div>
        <hr className="tw-bg-[#D2D2D2] tw-h-[1px] tw-w-full tw-my-[20px] md:tw-hidden" />
        {isGestor ? (
          <div
            className={
              isMobile ? 'tw-bg-[#EBEBEB] tw-rounded-md tw-text-[1rem]' : ''
            }
          >
            <div
              className={
                isMobile ? 'tw-font-bold tw-text-[1rem]' : 'tw-font-bold'
              }
            >
              Alterar modo de visualização
            </div>

            <div
              className={
                isMobile
                  ? 'tw-flex tw-flex-col tw-gap-[10px] tw-mt-[10px]'
                  : 'tw-flex tw-gap-2'
              }
            >
              <div className="tw-flex tw-gap-1">
                <div className="tw-flex tw-items-center tw-gap-1">
                  <input
                    name="options"
                    value="gestao"
                    onChange={(e) => {
                      handleVisualizationState(e.target.value);
                    }}
                    type="radio"
                    checked={visualizationState === 'gestao'}
                    className={
                      isMobile ? 'tw-text-[1.2rem] tw-font-bold' : 'tw-text-2xl'
                    }
                  />
                  <div className={isMobile ? 'tw-text-[1rem]' : ''}>
                    Modelo de Gestão
                  </div>
                </div>
              </div>
              <div className="tw-flex tw-items-center tw-gap-1">
                <div>
                  <input
                    name="options"
                    type="radio"
                    value="card"
                    onChange={(e) => {
                      handleVisualizationState(e.target.value);
                    }}
                    checked={visualizationState === 'card'}
                    className={
                      isMobile ? 'tw-text-[1.2rem] tw-font-bold' : 'tw-text-2xl'
                    }
                  />
                </div>
                <div className={isMobile ? 'tw-text-[1rem]' : ''}>
                  Modelo de Cards
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
